import styles from "./EnquiryModal.module.css";

interface EnquiryErrorViewProps {
  onRetry: () => void;
}

function EnquiryErrorView(props: EnquiryErrorViewProps) {
  const { onRetry } = props;

  return (
    <div className={styles.errorMessage}>
      <h2 className={styles.title}>Oops, something went wrong</h2>
      <p>
        We're sorry, but there was an error submitting your enquiry. Please try
        again or call us on <a href="tel:08000436644">0800 043 6644</a> to speak
        with one of our golf specialists.
      </p>
      <button className={styles.tryAgainButton} onClick={onRetry}>
        Try Again
      </button>
    </div>
  );
}

export default EnquiryErrorView;
export { EnquiryErrorView, type EnquiryErrorViewProps };
